import { FieldError } from "@/components/FieldError";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    ModalBody,
    ModalFooter,
} from "@chakra-ui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

export const schema = z.object({
    nomecidade: z.string().min(1, "Campo obrigatório"),
    nomefantasia: z.string().min(1, "Campo obrigatório"),
    numero: z.string().min(1, "Campo obrigatório"),
    telefone: z.string().min(1, "Campo obrigatório"),
    estado: z.string().min(1, "Campo obrigatório"),
    endereco: z.string().min(1, "Campo obrigatório"),
    codcidade: z.string().min(1, "Campo obrigatório"),
    cnpj: z.string().min(1, "Campo obrigatório"),
    codigo: z.string().min(1, "Campo obrigatório"),
    bairro: z.string().min(1, "Campo obrigatório"),
    ativo: z.string().min(1, "Campo obrigatório"),
    cep: z.string().min(1, "Campo obrigatório"),
});
export type FormType = z.infer<typeof schema>;

interface Props {
    handleCancel: () => void;
    handleSave: (data: FormType) => Promise<any>;
}

export function AddForm({ handleCancel, handleSave }: Props) {
    const {
        handleSubmit,
        register,
        formState: { isLoading, errors },
    } = useForm<FormType>({
        resolver: zodResolver(schema),
    });

    const handleSubmitWithoutPropagation = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        handleSubmit(handleSave)(e);
    };

    return (
        <form onSubmit={handleSubmitWithoutPropagation}>
            <ModalBody>
                <FormControl isInvalid={!!errors.nomefantasia}>
                    <FormLabel>Nome:</FormLabel>
                    <Input {...register("nomefantasia")} />
                    <FieldError error={errors.nomefantasia} />
                </FormControl>
            </ModalBody>
            <ModalFooter gap={5} pt={10}>
                <Button colorScheme="gray" onClick={handleCancel}>
                    Cancelar
                </Button>
                <Button
                    colorScheme="blue"
                    type="submit"
                    isLoading={isLoading}
                    onClick={handleSubmitWithoutPropagation}
                >
                    Salvar
                </Button>
            </ModalFooter>
        </form>
    );
}
